import { render, staticRenderFns } from "./config-GS.vue?vue&type=template&id=6c26361f"
import script from "./config-GS.vue?vue&type=script&lang=js"
export * from "./config-GS.vue?vue&type=script&lang=js"
import style0 from "./config-GS.vue?vue&type=style&index=0&id=6c26361f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports